const APIS = {
    DEFAULT_BRANCH: "/logisticservice/api/branch/default-branch/",
    STAFF: "/logisticservice/api/staff/",
    USER: "/logisticservice/api/user/",
    USER_PROFILE: "/logisticservice/api/user-profile/",
    REFERENCE_TYPE:"/logisticservice/api/reference-type/"
  };
  
  export default APIS;